import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CreateResponse, SingleResponse } from '@shared/models';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Distributor, DistributorList, DistributorPayload } from '../../models/distributors/distributor';
@Injectable({
  providedIn: 'root'
})
export class DistributorService {
  _apiUrl = environment.apiUrl;
  _http = inject(HttpClient);
  private _authHeaders = new HttpHeaders({
    Authorization: '',
  });

  createDistributor(
    distributorForm: DistributorPayload
  ): Observable<Distributor> {
    return this._http
      .post<CreateResponse<Distributor>>(
        `${this._apiUrl}/api/distributor/register`,
        distributorForm,
        { headers: this._authHeaders }
      )
      .pipe(map((resp) => resp.data));
  }

  getAllDistributors(): Observable<any> {
    let currentPage = 1;
    let allDistributors: any[] = [];

    return new Observable<any[]>((observer) => {
      const fetchPage = () => {
        this._http
          .get<any>(
            `${this._apiUrl}/api/distributor/list?page=${currentPage}`,
            {
              headers: this._authHeaders,
            }
          )
          .subscribe({
            next: (resp) => {
              allDistributors = allDistributors.concat(resp.data); 
              if (resp.next_page_url) {
                currentPage++; 
                fetchPage();
              } else {
                observer.next(allDistributors); 
                observer.complete();
              }
            },
            error: (error) => observer.error(error),
          });
      };

      fetchPage(); 
    });
  }

  public getDistributors(queryParams?: Partial<any>): Observable<DistributorList> {
    let params = new HttpParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value) {
          params = params.set(key, value);
        }
      });
    }

    return this._http
      .get<DistributorList>(`${this._apiUrl}/api/distributor/list`, {
        headers: this._authHeaders,
        params: params
      })
      .pipe(
        map((resp) => {
          const distributorList: DistributorList = {
            pagination: resp.pagination,
            last_page: resp.last_page,
            data: resp.data.map((distributorResponse) => {
              const distributor: Distributor = {
                id: distributorResponse.id,
                email: distributorResponse.email,
                id_number: distributorResponse.id_number,
                phone_number: distributorResponse.phone_number,
                profile: distributorResponse.profile,
                role_id: distributorResponse.role_id,
                name: distributorResponse.name,
                business_name: distributorResponse.business_name,
                address: distributorResponse.address,
                region: distributorResponse.region,
                region_id: distributorResponse.region_id,
                commerce_id: distributorResponse.commerce_id,
                products: distributorResponse.products,
                institutions: distributorResponse.institutions,
                medics: distributorResponse.medics,
                user_id: distributorResponse.user_id
              };
              return distributor;
            }),
          };
          return distributorList;
        })
      );
  }

  getDistributorById(id: number): Observable<Distributor> {
    return this._http.get<SingleResponse<Distributor>>(
      `${this._apiUrl}/api/distributor/${id}`,
      { headers: this._authHeaders }
    ).pipe(map(resp => resp.data));
  }
}
